/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseFieldPreviewOptions
 */
export interface DatabaseFieldPreviewOptions {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldPreviewOptions
     */
    list?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldPreviewOptions
     */
    grid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldPreviewOptions
     */
    gallery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldPreviewOptions
     */
    masterDbIdentifier?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldPreviewOptions
     */
    gridConditional?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldPreviewOptions
     */
    galleryConditional?: boolean;
}

/**
 * Check if a given object implements the DatabaseFieldPreviewOptions interface.
 */
export function instanceOfDatabaseFieldPreviewOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFieldPreviewOptionsFromJSON(json: any): DatabaseFieldPreviewOptions {
    return DatabaseFieldPreviewOptionsFromJSONTyped(json, false);
}

export function DatabaseFieldPreviewOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFieldPreviewOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': !exists(json, 'list') ? undefined : json['list'],
        'grid': !exists(json, 'grid') ? undefined : json['grid'],
        'gallery': !exists(json, 'gallery') ? undefined : json['gallery'],
        'masterDbIdentifier': !exists(json, 'masterDbIdentifier') ? undefined : json['masterDbIdentifier'],
        'gridConditional': !exists(json, 'gridConditional') ? undefined : json['gridConditional'],
        'galleryConditional': !exists(json, 'galleryConditional') ? undefined : json['galleryConditional'],
    };
}

export function DatabaseFieldPreviewOptionsToJSON(value?: DatabaseFieldPreviewOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': value.list,
        'grid': value.grid,
        'gallery': value.gallery,
        'masterDbIdentifier': value.masterDbIdentifier,
        'gridConditional': value.gridConditional,
        'galleryConditional': value.galleryConditional,
    };
}

